<template>
  <div class="screen-height-container">
    <v-card
      :class="context != 'popup' ? 'fullHeight' : ''"
      id="facilitystatus"
      :loading="isLoading"
    >
      <v-card-title class="pb-0">
        <h2>Operational Status</h2>
        <v-spacer />
        <div
          style="width: 50px; height: 50px"
          class="redlight hidden-lg-and-up"
        />
        <help-button help-topic-key="dashboards-operational-status-scorecard"></help-button>
        <v-btn
          icon
          class="mr-0 ml-0"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="primary"
                class="rotateanimation"
                v-on:click="refresh"
                >autorenew</v-icon
              >
            </template>
            <span>Reload Data</span>
          </v-tooltip>
        </v-btn>
      </v-card-title>

      <v-card-text
        class="pt-0"
        :class="context != 'popup' ? 'fullheighttext' : ''"
        :loading="isLoading"
      >
        <v-tabs
          v-model="tab"
          centered
        >
          <v-tab
            v-for="item in scorecardData"
            :key="item.areaname"
          >
            {{ item.areaname }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in scorecardData"
            :key="'itemDetail' + item.areaname"
          >
            <div
              class="datapoint"
              style="padding-top: 20px"
            >
              <label>Avg/Min/Max Temp:</label>
              <span>{{ item.temps.tempAverage }} / {{ item.temps.tempMin }} / {{ item.temps.tempMax }}</span>
            </div>
            <div class="datapoint">
              <label>Avg/Min/Max RH:</label>
              <span
                >{{ Math.round(item.rh.current * 100) }}% / {{ Math.round(item.rh.minReading * 100) }}% /
                {{ Math.round(item.rh.maxReading * 100) }}%</span
              >
            </div>

            <div class="datapoint">
              <label>Avg/Min/Max CO<sub>2</sub>:</label>
              <span>{{ item.co2.avg }} ppm / {{ item.co2.min }} ppm / {{ item.co2.max }} ppm</span>
            </div>

            <div class="datapoint">
              <label>Empty VFUs:</label>
              <span>
                {{ item.growPlatformsCount.platformGroupCount - item.growPlatformsInUse.platformsInUseCount }}
                /
                {{
                  (
                    (item.growPlatformsInUse.platformsInUseCount / item.growPlatformsCount.platformGroupCount) *
                    100
                  ).toFixed(1)
                }}% Utilization
              </span>
            </div>

            <div class="datapoint">
              <label>Clones:</label>
              <span>
                {{ item.clonePlants }}
              </span>
            </div>

            <div class="datapoint">
              <label>Plants in Veg:</label>
              <span>
                {{ item.vegPlants }}
              </span>
            </div>

            <div class="datapoint">
              <label>Plants in Flower:</label>
              <span>
                {{ item.flowerPlants }}
              </span>
            </div>

            <div class="datapoint">
              <label>Disabled Racks:</label>
              <span>
                {{ item.disabledUnits }}
              </span>
            </div>

            <div class="datapoint">
              <label>Open Tickets:</label>
              <span>
                {{ item.tickets }}
              </span>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <!--
        <div v-show="!isLoading" style="padding-top: 30px" />
        <v-row>
          <v-col md="12" lg="12">
            <div class="datapoint">
              <label>Avg/Min/Max Temp:</label>
              <span>{{temperatures.tempAverage}} / {{temperatures.tempMin}} / {{temperatures.tempMax}}</span>
            </div>

            <div class="datapoint">
              <label>Avg/Min/Max CO2:</label>
              <span>{{co2.avg}} ppm / {{co2.min}} ppm / {{co2.max}} ppm</span>
            </div>

            <div class="datapoint">
              <template v-for="license in facilityLicenses">
                <div :key="license.id">
                  <label>{{license.label}} Plants:</label>
                  <span>{{license.plantCount}} / {{license.maxPlants}}</span>
                </div>
              </template>
            </div>
            <div class="datapoint">
              <label>Plant Positions:</label>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{utilization.utilization}} filled</span>
                </template>
                <span>{{utilization.filled}} / {{utilization.totalpositions}} plant positions filled</span>
              </v-tooltip>
            </div>

            <div class="datapoint">
              <label>Grow Units with Plants:</label>
              <span>{{growUnitsInUse}} / {{growUnits}} ({{growUnitsInUsePercentage}} %)</span>
            </div>

            <div class="datapoint">
              <label>Open hardware tickets:</label>
              <span>{{openHardwareTicketsCount}}</span>
            </div>

            <div class="datapoint">
              <label>Disabled grow units:</label>
              <span>{{disabledUnitsCount}}</span>
            </div>
            <div class="datapoint">
              <label>Expiring Licenses:</label>
              <span>{{expiringLicencesCount}}</span>
            </div>
            <div class="datapoint">
              <label>Late grow tasks:</label>
              <span>{{lateTasksCount}}</span>
            </div>
          </v-col>
        
        </v-row>
        -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Trimaster from '@/plugins/servers/trimaster.js';
import moment from 'moment';
import vuetifyToast from '@/vuetifyToast.js';
import { mapGetters, mapActions } from 'vuex';
import HelpButton from '@/components/systemadmin/helpTopics/HelpButton';
import Scorecard from '@/mixins/Scorecard.js';

export default {
  name: 'facilitystatus',

  props: ['context', 'active'],
  components: { HelpButton },
  mixins: [Scorecard],
  beforeMount() {
    if (this.context != 'popup') {
      this.timer = setInterval(this.refresh, 120000);
      this.refresh();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {},

  data() {
    return {
      timer: null,
      tab: 0,
      scorecardData: [],
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(['getUser']),
  },
  watch: {
    active(newVal, oldVal) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.context == 'popup' && newVal) {
        this.timer = setInterval(this.refresh, 60000);
        this.refresh();
      }
    },
  },
  methods: {
    refresh() {
      let me = this;
      me.isLoading = true;
      this.getStats(this.getUser, function (res) {
        me.scorecardData = res;
        console.log('scorecarddata', me.scorecardData);
        me.isLoading = false;
      });
    },
  },
};
</script>
<style>
.redlight {
  background-image: url('/img/icons/trafficlight/trafficlight_red.ico');
  background-size: contain;
  background-position: top center;
}

#facilitystatus .datapoint {
  clear: both;
  margin-bottom: 15px !important;
}
#facilitystatus .datapoint span {
  font-size: 1em;
}

#facilitystatus .datapoint label {
  font-size: 1em;
  display: inline-block;
  width: 150px;
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
}

#facilitystatus.fullHeight {
  height: 100%;
}

#facilitystatus .fullheighttext {
  height: calc(100% - 70px);
  overflow: auto;
}
</style>
